import { Link } from "react-router-dom";
import { renderEstado } from "../../../common/utils/functions/renderEstado.jsx";
import { truncatedCellTooltip } from "../../../common/utils/functions/truncatedCellTooltip.jsx";
import formatCurrencyForUi from "../../../common/utils/functions/formatCurrencyForUi.js";

// Función para renderizar el enlace "Ver más"
const renderVerMas = (idComprobante) => (
  <Link 
    to={`/detalle-factura/${idComprobante}`}
    className="text-blue-600 hover:text-blue-800 underline font-semibold text-xs"
  >
    Ver más
  </Link>
);

// Configuración de columnas para la tabla
export const getTableColumns = (includeSectorDestination = false) => {
  const cols = [
    {
      key: "RAZON_SOCIAL",
      label: "Razón social",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "text-center whitespace-normal align-center w-[120px]",
      cellClassName: "text-left",
    },
    {
      key: "CUIT",
      label: "CUIT",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "text-center w-[90px]",
    },
    {
      key: "NRO_COMPROBANTE",
      label: "N° Comprobante",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "w-[100px]",
    },
    {
      key: "TIPO",
      label: "Tipo",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "w-[80px]",

    },
    {
      key: "ORDEN_COMPRA",
      label: "OC",
      sorted: true,
      fixed: false,
      type: "number",
      headerClassName: "w-[70px]",
    },
    {
      key: "FECHA_RECEPCION",
      label: "Recepción",
      sorted: true,
      fixed: false,
      type: "date",
      headerClassName: "w-[80px]",
    },
    {
      key: "IMPORTE",
      label: "Importe",
      sorted: true,
      fixed: false,
      type: "number",
      sortKey: "currency", // Indica al Table que debe parsear como moneda
      headerClassName: "w-[100px]",
    },
  ];

  if (includeSectorDestination) {
    const sectorColumn = {
      key: "FE_SECTORDESTINO",
      label: "Sector",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "w-[100px]",
    };
    const cuitIndex = cols.findIndex(c => c.key === "CUIT");
    if (cuitIndex !== -1) {
      cols.splice(cuitIndex + 1, 0, sectorColumn);
    } else {
      cols.push(sectorColumn);
    }
  }

  cols.push(
    {
      key: "ESTADOCOMPROBANTE",
      label: "Estado",
      sorted: true,
      fixed: false,
      type: "string",
      headerClassName: "w-[100px]",
      cellClassName: "text-left",
    },
    {
      key: "VER_MAS",
      label: "",
      sorted: false,
      fixed: false,
      type: "string",
      headerClassName: "text-center w-[65px]",
      cellClassName: "text-center",
    }
  );

  return cols;
};

// Función para transformar los datos de la tabla
export const transformTableData = (data) => {
  return data.map(item => ({
    ...item,
    RAZON_SOCIAL: truncatedCellTooltip(item.RAZON_SOCIAL),
    IMPORTE: `$ ${formatCurrencyForUi(item.IMPORTE)}`,
    ESTADOCOMPROBANTE: renderEstado(item.ESTADOCOMPROBANTE),
    VER_MAS: renderVerMas(item.ID_COMPROBANTE)
  }));
};

export { renderEstado, renderVerMas };
